<div class="modal-header shared-arts-header">
  <div>
         <h4 class="modal-title">Artes compartidos</h4>
    <p class="dialog-context">{{ data.campaing?.name || 'Campaña' }} - {{ data.project?.nombre || data.project?.name || 'Proyecto' }}
      <ng-container *ngIf="filaSeleccionada"> {{ filaSeleccionada.medio }} - {{ filaSeleccionada.pop }}</ng-container>
      <ng-container *ngIf="arteSeleccionado"> {{ arteSeleccionado.fila.medio }} - {{ arteSeleccionado.fila.pop }} - {{ arteSeleccionado.fase.name }}</ng-container>
    </p>
  </div>
       <button type="button" class="btn-close" [mat-dialog-close]="{ reload: huboCambiosGuardados }" aria-label="Cerrar"></button>
</div>
<!--tabla principal-->
<mat-dialog-content class="shared-arts-content listado-content" *ngIf="!filaSeleccionada && !arteSeleccionado && !data.vistaDirecta">
       <p class="dialog-help">Elementos POP con artes compartidos entre posiciones. Haz clic en el círculo <strong>ART</strong> para gestionar y adjuntar los archivos, o en un área para dar los VoBos. Nota: El envío del formulario a proveedores no se muestra en la sección de fases.</p>
       <div class="filtros">
         <mat-form-field appearance="outline" class="buscador">
           <mat-label>Buscar medio o POP</mat-label>
           <mat-icon matPrefix>search</mat-icon>
           <input matInput type="search" (input)="buscar($event)" placeholder="Escribe un medio o elemento POP">
         </mat-form-field>
       <!--  <mat-slide-toggle [checked]="mostrarNoDiagramados" (change)="cambiarVisibilidadNoDiagramados($event.checked)">
           Mostrar POPs sin diagramar
         </mat-slide-toggle>-->
       </div>
       <div class="estado-carga" *ngIf="loading"><mat-spinner diameter="34"></mat-spinner><span>Cargando medios y elementos POP...</span></div>
       <div class="table-wrapper mat-elevation-z8 " [class.d-none]="loading">

         <table mat-table [dataSource]="dataSource" matSort matSortActive="medio" matSortDirection="asc" class="shared-arts-table">

          <ng-container matColumnDef="medio">
             <th mat-header-cell *matHeaderCellDef mat-sort-header>Medio</th>
             <td mat-cell *matCellDef="let row" class="medio-cell">{{ row.medio }}</td>
           </ng-container>
           <ng-container matColumnDef="pop">
             <th mat-header-cell *matHeaderCellDef mat-sort-header>POP</th>
             <td mat-cell *matCellDef="let row" class="pop-cell">{{ row.pop }}</td>
          </ng-container>
           <ng-container matColumnDef="positions">
             <th mat-header-cell *matHeaderCellDef>Posiciones</th>
             <td mat-cell *matCellDef="let row" class="positions-cell">
               <div class="project-positions-list">
                 <section class="project-position-row" *ngFor="let group of row.phaseGroups">
                   <div class="project-position-name">{{ group.nombreProyecto }}</div>
                   <div><strong>{{ group.posicionesDiagramadas.length }}</strong><span class="muted">/{{ group.totalPosiciones }} posiciones diagramadas</span></div>
                   <div class="muted">{{ group.posicionesAnotadas.length }} con arte anotado - {{ group.totalPosiciones - group.posicionesDiagramadas.length }} espacios libres</div>
                   <div class="position-markers">
                     <span *ngFor="let position of posicionesDisponibles(group.totalPosiciones); trackBy: trackPosition"
                       class="position-marker" [ngClass]="estadoPosicionProyecto(group, position)"
                       [matTooltip]="'Posición ' + position + (group.posicionesAnotadas.includes(position) && !group.posicionesDiagramadas.includes(position) ? ' · anotada sin diagramación' : (group.posicionesAnotadas.includes(position) ? ' · diagramada y anotada' : (group.posicionesDiagramadas.includes(position) ? ' · diagramada sin anotación' : ' · espacio libre'))) "></span>
                   </div>
                 </section>
               </div>
               <button mat-flat-button class="positions-button" (click)="verPosiciones(row)"><mat-icon>format_list_bulleted</mat-icon> Ver posiciones</button>
             </td>
           </ng-container>

           <ng-container matColumnDef="road">
             <th mat-header-cell *matHeaderCellDef>Flujo de VoBos por posición</th>
             <td mat-cell *matCellDef="let row" class="flow-cell">
               <div class="flujo-horizontal">
                 <section class="project-phase-group" *ngFor="let group of row.phaseGroups">
                   <div class="project-name">{{ group.nombreProyecto }}</div>
                   <div class="project-phases">
                     <section class="phase-flow" *ngFor="let phase of group.fases; trackBy: trackPhase">
                       <div class="phase-name">{{ phase.name }}</div>
                       <div class="indicadores">
                         <div class="indicador" *ngFor="let indicador of phase.indicadores; trackBy: identificarIndicador" [matTooltip]="indicador.name">
                           <button type="button" class="indicador-circulo" [ngClass]="indicador.status" (click)="accionIndicador(row, phase, indicador)" [attr.aria-label]="indicador.name + ': ' + indicador.completed + ' de ' + indicador.total">{{ indicador.label }}</button>
                           <span class="indicador-contador" [ngClass]="indicador.status">{{ indicador.completed }}/{{ indicador.total }}</span>
                         </div>
                       </div>
                     </section>
                   </div>
                 </section>
               </div>
             </td>
           </ng-container>
           <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
           <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
           <tr class="mat-row" *matNoDataRow><td class="mat-cell estado-vacio" [attr.colspan]="displayedColumns.length">{{ loadError ? 'No fue posible cargar el catálogo completo.' : 'No hay combinaciones de medio y POP disponibles.' }}</td></tr>
         </table>
       </div>
       <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons></mat-paginator>
</mat-dialog-content>

<div class="legend legend-fija" *ngIf="!filaSeleccionada && !arteSeleccionado && !data.vistaDirecta && !loading && dataSource.data.length">
  <span><i class="legend-dot complete"></i> Completo - todas las posiciones aprobadas</span>
  <span><i class="legend-dot partial"></i> Parcial</span>
  <span><i class="legend-dot error"></i> Rechazado - todas las posiciones rechazadas</span>
  <span><i class="legend-dot empty"></i> Sin iniciar</span>
  <span><i class="legend-box annotated"></i> Diagramada con arte anotado</span>
  <span><i class="legend-box annotated-without-diagram"></i> Arte anotado sin diagramación</span>
  <span><i class="legend-box diagrammed"></i> Diagramada sin arte</span>
  <span><i class="legend-box free"></i> Espacio libre del medio</span>
</div>

<!--carga de artes-->
<mat-dialog-content class="shared-arts-content artes-content" *ngIf="arteSeleccionado && !archivoAnotando">
  <button *ngIf="!data.vistaDirecta" mat-button color="primary" class="volver-button" (click)="volverDesdeArtes()"><mat-icon>arrow_back</mat-icon> Volver al listado</button>

  <div class="artes-encabezado">
    <p>Historial de archivos del arte compartido. El archivo más reciente es el vigente.</p>
    <button mat-raised-button color="primary" (click)="abrirSubidaArte()">
      <mat-icon>upload</mat-icon> Cargar nuevo archivo
    </button>
  </div>

  <div class="estado-carga" *ngIf="cargandoArtes">
    <mat-spinner diameter="34"></mat-spinner><span>Cargando historial de artes...</span>
  </div>

  <div class="tabla-artes table-responsive text-nowrap" *ngIf="!cargandoArtes && archivosArte.length">
    <table class="table table-hover overflow-auto">
      <thead>
        <tr>
          <th>Archivo</th>
          <th>Versión</th>
          <th>Subido por</th>
          <th>Fecha</th>
          <th>Posiciones anotadas</th>
          <th>Estado</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody class="table-border-bottom-0">
        <tr *ngFor="let archivo of archivosArte">
          <td><div class="archivo-tabla"><span class="extension-archivo">{{ extensionArchivo(archivo) }}</span><strong>{{ archivo.name || 'Archivo sin nombre' }}</strong></div></td>
          <td><strong>v{{ archivo.version }}</strong></td>
          <td>{{ nombreUsuarioArchivo(archivo) }}</td>
          <td>{{ archivo.created_at | date:'dd/MM/yyyy' }}</td>
          <td>
            <div class="anotaciones-archivo">
              <span class="barra-anotaciones"><i [style.width.%]="porcentajeAnotado(archivo)"></i></span>
              <strong>{{ archivo.posicionesAnotadas }}/{{ arteSeleccionado.fila.totalPositions }}</strong>
            </div>
          </td>
          <td>
            <span class="badge" [ngClass]="archivo.vigente ? 'badge-success' : 'badge-inverse'">
              {{ archivo.vigente ? 'Vigente' : 'Reemplazado' }}
            </span>
          </td>
          <td class="acciones-archivo">
            <button *ngIf="archivo.vigente" mat-flat-button (click)="anotarArchivo(archivo)"><mat-icon>edit</mat-icon> Anotar</button>
            <button *ngIf="!archivo.file && archivo.imagenes?.length" mat-button color="primary" (click)="abrirVisorImagenes(archivo)">Ver</button>
            <a *ngIf="archivo.file" mat-button color="primary" [href]="archivo.file" target="_blank" rel="noopener noreferrer">Ver</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="estado-vacio artes-vacio" *ngIf="!cargandoArtes && !archivosArte.length">
    <mat-icon>{{ errorArtes ? 'error_outline' : 'insert_drive_file' }}</mat-icon>
    <span>{{ errorArtes ? 'No fue posible cargar el historial de artes.' : 'Todavía no hay archivos de arte compartido.' }}</span>
  </div>
</mat-dialog-content>

<!-- Anotacion del arte compartido -->
<mat-dialog-content class="shared-arts-content anotacion-content" *ngIf="arteSeleccionado && archivoAnotando">
  <button mat-button color="primary" class="volver-button" (click)="volverAlHistorial()">
    <mat-icon>arrow_back</mat-icon> Volver al historial
  </button>

  <div class="editor-anotacion">
    <section class="panel-imagen">
      <header class="archivo-anotacion-header">
        <div>
          <mat-icon>{{ esPdfActual ? 'picture_as_pdf' : (esImagenesMultiplesActual ? 'collections' : 'insert_drive_file') }}</mat-icon>
          <div>
            <strong>{{ archivoAnotando.name || 'Archivo sin nombre' }}</strong>
            <span>v{{ archivoAnotando.version }} - {{ esPdfActual ? 'PDF' : (esImagenesMultiplesActual ? 'Imágenes' : 'Imagen') }} para {{ arteSeleccionado.fila.pop }}</span>
          </div>
        </div>
        <div class="controles-archivo">
          <div class="controles-pagina" *ngIf="esPdfActual || esImagenesMultiplesActual">
            <button mat-stroked-button (click)="cambiarPaginaPdf(paginaActual - 1)" [disabled]="paginaActual <= 1 || cargandoImagen" [matTooltip]="esImagenesMultiplesActual ? 'Imagen anterior' : 'Página anterior'">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <span>{{ esImagenesMultiplesActual ? 'Imagen' : 'Página' }} {{ paginaActual }} de {{ totalPaginas || 1 }}</span>
            <button mat-stroked-button (click)="cambiarPaginaPdf(paginaActual + 1)" [disabled]="paginaActual >= totalPaginas || cargandoImagen" [matTooltip]="esImagenesMultiplesActual ? 'Imagen siguiente' : 'Página siguiente'">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
          <div class="controles-zoom">
            <button mat-stroked-button (click)="alejarImagen()" [disabled]="nivelZoom <= 0.5" matTooltip="Alejar archivo">
              <mat-icon>remove</mat-icon>
            </button>
            <span>{{ nivelZoom * 100 | number:'1.0-0' }}%</span>
            <button mat-stroked-button (click)="acercarImagen()" [disabled]="nivelZoom >= 2.5" matTooltip="Acercar archivo">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </header>

      <div #visorAnotacion class="visor-anotacion">
        <div class="cargando-imagen" *ngIf="cargandoImagen"><mat-spinner diameter="34"></mat-spinner><span>Cargando imagen...</span></div>
        <div class="error-imagen" *ngIf="errorImagen">
          <mat-icon>{{ esPdfActual ? 'picture_as_pdf' : 'broken_image' }}</mat-icon>
          <span>No fue posible mostrar {{ esPdfActual ? 'el PDF' : 'la imagen' }}.</span>
        </div>
        <div class="superficie-anotacion"
          *ngIf="!errorImagen && (fuenteImagen || esPdfActual)"
          [style.width.px]="anchoBase * nivelZoom"
          [style.height.px]="altoBase * nivelZoom"
          (pointerdown)="iniciarSeleccion($event)"
          (pointermove)="moverSeleccion($event)"
          (pointerup)="terminarSeleccion($event)"
          (pointercancel)="cancelarSeleccion()">
          <img *ngIf="!esPdfActual" [src]="fuenteImagen" alt="Arte compartido para anotar" draggable="false"
            (load)="imagenCargada($event)" (error)="errorAlCargarImagen()">
          <canvas *ngIf="esPdfActual" #lienzoPdf aria-label="Página del PDF para anotar"></canvas>
          <div class="area-anotada" *ngFor="let anotacion of anotacionesPaginaActual" [ngStyle]="estiloAnotacion(anotacion)">
            <span [style.background]="anotacion.color">Pos. {{ anotacion.posicion }} - {{ anotacion.alias }}</span>
          </div>
          <div class="area-anotada area-pendiente" *ngIf="anotacionTemporal" [ngStyle]="estiloAnotacion(anotacionTemporal)">
            <span>Área pendiente</span>
          </div>
        </div>
      </div>
    </section>

    <aside class="panel-configuracion">
      <section class="ayuda-anotacion">
        <mat-icon>gesture</mat-icon>
        <span *ngIf="posicionesParaAsignar.length; else todasMarcadas">Dibuja un rectángulo sobre el arte y asígnalo a una posición de la diagramación.</span>
        <ng-template #todasMarcadas><span>Todas las posiciones diagramadas ya se encuentran marcadas.</span></ng-template>
      </section>

      <section class="asignar-posicion" *ngIf="anotacionTemporal">
        <h6>Asignar posición</h6>
        <p>¿A qué posición de la diagramación corresponde esta región?</p>
        <mat-form-field appearance="outline">
          <mat-label>Posición</mat-label>
          <mat-select [(value)]="posicionPendiente" (selectionChange)="asignarPosicion($event.value)">
            <mat-option *ngFor="let posicion of posicionesParaAsignar" [value]="posicion.numero">
              Posición {{ posicion.numero }} - {{ posicion.alias }}<ng-container *ngIf="posicion.diagramada"> ({{ posicion.promociones }} promo(s))</ng-container>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-accordion *ngIf="posicionSeleccionadaPendiente?.diagramada" class="acordeon-promos-anotacion">
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>Promociones</mat-panel-title>
              <mat-panel-description>{{ posicionSeleccionadaPendiente.promociones }} promo(s)</mat-panel-description>
            </mat-expansion-panel-header>
            <div class="promociones-anotacion-contenido">
              <div class="cargando-promociones" *ngIf="cargandoPromocionesAnotacion">
                <mat-spinner diameter="20"></mat-spinner> Cargando promociones...
              </div>
              <div class="tabla-promociones-anotacion" *ngIf="!cargandoPromocionesAnotacion && posicionSeleccionadaPendiente.promocionesDetalle.length">
                <table mat-table [dataSource]="posicionSeleccionadaPendiente.promocionesDetalle">
                  <ng-container *ngFor="let columna of columnasPromocionesAnotacion" [matColumnDef]="columna">
                    <th mat-header-cell *matHeaderCellDef>{{ columna }}</th>
                    <td mat-cell *matCellDef="let promocion">{{ promocion[columna] }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="columnasPromocionesAnotacion; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: columnasPromocionesAnotacion"></tr>
                </table>
              </div>
              <span class="sin-anotaciones" *ngIf="!cargandoPromocionesAnotacion && !posicionSeleccionadaPendiente.promocionesDetalle.length">
                Esta posición no tiene promociones.
              </span>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div *ngIf="posicionSeleccionadaPendiente && !posicionSeleccionadaPendiente.diagramada" class="posicion-sin-diagramar">
          <mat-icon>info_outline</mat-icon>
          <span>Esta posición aún no se encuentra diagramada, por lo que no tiene promociones asociadas.</span>
        </div>
        <div class="acciones-asignacion">
          <button mat-button (click)="cancelarSeleccion()">Cancelar</button>
        </div>
      </section>

      <section class="posiciones-marcadas">
        <h6>Posiciones marcadas ({{ anotaciones.length }} de {{ arteSeleccionado.fila.totalPositions }})</h6>
        <p>Pasa el cursor sobre las áreas para ubicarlas en el arte.</p>

        <div class="lista-anotaciones" *ngIf="anotaciones.length; else sinAnotaciones">
          <article *ngFor="let anotacion of anotaciones">
            <i [style.background]="anotacion.color"></i>
            <div class="datos-anotacion">
              <strong>Pos. {{ anotacion.posicion }} - {{ anotacion.alias }} <ng-container *ngIf="esPdfActual || esImagenesMultiplesActual"> - {{ esImagenesMultiplesActual ? 'Imagen' : 'Página' }} {{ anotacion.pagina }}</ng-container></strong>
            </div>
            <button *ngIf="(esPdfActual || esImagenesMultiplesActual) && anotacion.pagina !== paginaActual" mat-icon-button color="primary"
              (click)="cambiarPaginaPdf(anotacion.pagina)" [matTooltip]="'Ir a la ' + (esImagenesMultiplesActual ? 'imagen ' : 'página ') + anotacion.pagina">
              <mat-icon>find_in_page</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="eliminarAnotacion(anotacion)" matTooltip="Volver a seleccionar posición">
              <mat-icon>replay</mat-icon>
            </button>
            <mat-accordion *ngIf="anotacion.diagramada" class="acordeon-promos-anotacion">
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>Promociones</mat-panel-title>
                  <mat-panel-description>{{ anotacion.promocionesDetalle?.length || 0 }} promo(s)</mat-panel-description>
                </mat-expansion-panel-header>
                <div class="promociones-anotacion-contenido">
                  <div class="cargando-promociones" *ngIf="cargandoPromocionesAnotacion">
                    <mat-spinner diameter="20"></mat-spinner> Cargando promociones...
                  </div>
                  <div class="tabla-promociones-anotacion" *ngIf="!cargandoPromocionesAnotacion && anotacion.promocionesDetalle?.length">
                    <table mat-table [dataSource]="anotacion.promocionesDetalle">
                      <ng-container *ngFor="let columna of columnasPromocionesAnotacion" [matColumnDef]="columna">
                        <th mat-header-cell *matHeaderCellDef>{{ columna }}</th>
                        <td mat-cell *matCellDef="let promocion">{{ promocion[columna] }}</td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="columnasPromocionesAnotacion; sticky: true"></tr>
                      <tr mat-row *matRowDef="let row; columns: columnasPromocionesAnotacion"></tr>
                    </table>
                  </div>
                  <span class="sin-anotaciones" *ngIf="!cargandoPromocionesAnotacion && !anotacion.promocionesDetalle?.length">
                    Esta posición no tiene promociones.
                  </span>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
            <div *ngIf="!anotacion.diagramada" class="posicion-sin-diagramar">
              <mat-icon>info_outline</mat-icon>
              <span>Esta posición aún no se encuentra diagramada.</span>
            </div>
          </article>
        </div>
        <ng-template #sinAnotaciones><span class="sin-anotaciones">Aún no hay posiciones marcadas.</span></ng-template>

        <div class="acciones-guardado">
          <button mat-button (click)="volverAlHistorial()">Cancelar</button>
          <button mat-raised-button color="primary" (click)="guardarAnotaciones()"
            [disabled]="guardandoAnotaciones || cargandoImagen || errorImagen || anotacionTemporal">
            <mat-spinner *ngIf="guardandoAnotaciones" diameter="18"></mat-spinner>
            <mat-icon *ngIf="!guardandoAnotaciones">save</mat-icon>
            Guardar anotaciones
          </button>
        </div>
      </section>
    </aside>
  </div>
</mat-dialog-content>

<mat-dialog-content class="shared-arts-content detalle-content" *ngIf="filaSeleccionada">
  <button mat-button color="primary" class="volver-button" (click)="volverAlListado()"><mat-icon>arrow_back</mat-icon> Volver al listado</button>

  <div class="resumen-posiciones">
    <div><strong>{{ filaSeleccionada.totalPositions }}</strong><span>Permitidas por el medio</span></div>
    <div><strong>{{ filaSeleccionada.diagrammedPositions.length }}</strong><span>Diagramadas</span></div>
    <div><strong>{{ filaSeleccionada.annotatedPositions.length }}</strong><span>Con arte anotado</span></div>
    <div><strong>{{ filaSeleccionada.totalPositions - filaSeleccionada.diagrammedPositions.length }}</strong><span>Espacios libres</span></div>
    <div class="resumen-marcadores">
      <div class="position-markers">
        <span *ngFor="let position of posicionesDisponibles(filaSeleccionada.totalPositions); trackBy: trackPosition" class="position-marker" [ngClass]="estadoPosicion(filaSeleccionada, position)"></span>
      </div>
      <span>{{ filaSeleccionada.medio }} - {{ filaSeleccionada.pop }}</span>
    </div>
  </div>

  <div class="estado-carga" *ngIf="cargandoDetalle"><mat-spinner diameter="34"></mat-spinner><span>Cargando promociones...</span></div>

  <!-- Resumen de diagramaciones -->
  <section class="tarjeta-posicion" *ngFor="let detalle of detallePosiciones">
    <ng-container *ngIf="detalle.diagrama; else posicionLibre">
      <header class="posicion-header">
        <div><i class="indicador-posicion"></i><strong>Posición {{ detalle.numero }} - {{ detalle.diagrama.alias || 'Sin alias' }}</strong><span class="cantidad-promos">{{ detalle.promociones.length }} promo(s)</span><span class="arte-placeholder" [class.anotado]="detalle.arteAnotado">Arte anotado: {{ detalle.arteAnotado ? 'Anotado' : 'Pendiente' }}</span></div>
        <div class="vobos-posicion">
          <span *ngFor="let vobo of detalle.vobos" [class.aprobado]="vobo.aprobado" [class.rechazado]="vobo.rechazado">{{ vobo.nombre }} {{ vobo.aprobado ? '✓' : (vobo.rechazado ? '×' : '·') }}</span>
        </div>
      </header>
      <div class="comentarios"><strong>Comentarios</strong> {{ detalle.comentarios || '-' }}</div>
      <mat-accordion *ngIf="detalle.promociones.length && columnasPromociones.length; else sinPromociones">
        <mat-expansion-panel class="acordeon-promociones" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>Promociones</mat-panel-title>
            <mat-panel-description>{{ detalle.promociones.length }} promoción(es)</mat-panel-description>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="tabla-promociones">
              <table mat-table [dataSource]="detalle.promociones" class="w-100">
                <ng-container *ngFor="let columna of columnasPromociones" [matColumnDef]="columna">
                  <th mat-header-cell *matHeaderCellDef>{{ columna }}</th>
                  <td mat-cell *matCellDef="let promocion">{{ promocion[columna] }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columnasPromociones"></tr>
                <tr mat-row *matRowDef="let row; columns: columnasPromociones"></tr>
              </table>
            </div>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>
      <ng-template #sinPromociones><p class="sin-promociones">Esta diagramación no tiene promociones para mostrar.</p></ng-template>
    </ng-container>
    <ng-template #posicionLibre>
      <div class="posicion-libre"><i class="position-marker free"></i><strong>Posición {{ detalle.numero }}</strong><span>Posición no diagramada</span></div>
    </ng-template>
  </section>
</mat-dialog-content>
